/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Measure_Requests_WeeklyInputs */

const en_measure_requests_weekly = /** @type {(inputs: Measure_Requests_WeeklyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`30d · weekly, last ${i?.count} wks`)
};

const zh_hans1_measure_requests_weekly = /** @type {(inputs: Measure_Requests_WeeklyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`30d · 按周，近 ${i?.count} 周`)
};

const pt_br2_measure_requests_weekly = /** @type {(inputs: Measure_Requests_WeeklyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`30d · semanal, últimas ${i?.count} sem.`)
};

const es_measure_requests_weekly = /** @type {(inputs: Measure_Requests_WeeklyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`30d · semanal, últimas ${i?.count} sem.`)
};

const fr_measure_requests_weekly = /** @type {(inputs: Measure_Requests_WeeklyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`30 j · par semaine, ${i?.count} dernières sem.`)
};

const de_measure_requests_weekly = /** @type {(inputs: Measure_Requests_WeeklyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`30 T · wöchentlich, letzte ${i?.count} Wochen`)
};

const ru_measure_requests_weekly = /** @type {(inputs: Measure_Requests_WeeklyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`30 дн. · по неделям, последние недель: ${i?.count}`)
};

const it_measure_requests_weekly = /** @type {(inputs: Measure_Requests_WeeklyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`30 g · settimanale, ultime ${i?.count} sett.`)
};

/**
* | output |
* | --- |
* | "30d · weekly, last {count} wks" |
*
* @param {Measure_Requests_WeeklyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_requests_weekly = /** @type {((inputs: Measure_Requests_WeeklyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Requests_WeeklyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_requests_weekly(inputs)
	if (locale === "pt-BR") return pt_br2_measure_requests_weekly(inputs)
	if (locale === "es") return es_measure_requests_weekly(inputs)
	if (locale === "fr") return fr_measure_requests_weekly(inputs)
	if (locale === "de") return de_measure_requests_weekly(inputs)
	if (locale === "ru") return ru_measure_requests_weekly(inputs)
	if (locale === "it") return it_measure_requests_weekly(inputs)
	return en_measure_requests_weekly(inputs)
});